import { Button, Form } from "antd";
import { convertPersian, regexFormater, validateInput } from "../../../../tools/tools";
import ReactInputMask from "react-input-mask";
import { useTranslation } from "react-i18next";
import { _adr } from "../../../../address";
import "../paybill.scss";
import { useDealer } from "../../../../tools/api";
import { useDispatch } from "react-redux";
import { clearFormData } from "../../../../reducer/serviceReducer";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ShopPage from "../../../auxiliary/shop/ShopPage";
import { BILL_STEPS } from "../prefactor/prefactor";

const ValidPayBill = () => {
	const [t] = useTranslation("global");
	const [frmPayBill] = Form.useForm();
	const location = useLocation();
	const dispatch = useDispatch();
	const { queryHotBill } = useDealer();
	const nav = useNavigate();

	// a number handed over from 360 / search loads its bill straight away
	const [bill, setBill] = useState({
		purchase: location?.state || null,
		msisdn: location?.state?.msisdn || location?.state?.inT_MSISDN || "",
		valmsisdn: "",
	});

	useEffect(() => {
		if (bill?.msisdn) {
			frmPayBill.setFieldValue("msisdn", bill?.msisdn);
			loadPayBill();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const loadPayBill = async (values = null) => {
		dispatch(clearFormData(["paybill"]));
		const payload = {
			msisdn: bill?.msisdn || regexFormater(values.msisdn).removeSpace(),
			withdebt: true,
		};
		const response = await queryHotBill(payload);
		if (response) {
			nav(_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Prefactor, {
				state: { ...response, msisdn: payload.msisdn },
			});
		}
	};

	const handleSubmit = async (values) => {
		if (values.msisdn) loadPayBill(values);
	};

	// the bill amount is known only after the inquiry, so this step has no summary; the pre-invoice shows it
	return (
		<ShopPage title={t("payBill.title")} prefix="paybill" steps={BILL_STEPS} step={0}>
			<div className="charge-layout">
				<section className="shop-section">
					<h4>
						<span className="num">۱</span>شماره دائمی مشترک
					</h4>
					<Form id="frmPayBill" form={frmPayBill} onFinish={handleSubmit} className="number-row">
						<Form.Item className="input-normal" name="msisdn" rules={[validateInput({ t: t, validate: true, type: "msisdnOrg" })]}>
							<div>
								<ReactInputMask
									value={frmPayBill.getFieldValue("msisdn")?.length > 0 ? frmPayBill.getFieldValue("msisdn") : ""}
									onChange={(e) => {
										e.target.value = convertPersian(e.target.value);
										setBill((bill) => ({ ...bill, valmsisdn: e.target.value }));
									}}
									className="msisdn-mask"
									dir="ltr"
									inputMode="numeric"
									autoComplete="off"
									mask="0\9\9\99 99 99 99"
								/>
							</div>
						</Form.Item>
						<Form.Item>
							<Button className="btn-normal btn-aptel" type="primary" danger htmlType="submit">
								استعلام صورتحساب
							</Button>
						</Form.Item>
					</Form>
				</section>
			</div>
		</ShopPage>
	);
};

export default ValidPayBill;
